<template>
	<div>
		<AppHeader title="하이모 소식"></AppHeader>
		<AppContent>
			<PromotionList></PromotionList>
		</AppContent>
		<AppFooter></AppFooter>
	</div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';
import AppContent from '@/components/common/AppContent';
import AppFooter from '@/components/common/AppFooter';

import PromotionList from '@/components/PromotionList';

export default {
	components: {
		AppHeader,
		AppContent,
		AppFooter,
		PromotionList,
	},
};
</script>
